export default class HouseData {
    constructor(opts = {}) {
        this.id = opts.id; // id дома, если есть
        this.name = opts.full_address; // полное название объекта
        this.number = opts.name; // номер дома, если есть
        this.streetID = opts.street;
        this.street = opts.street_name || opts.streetName;
        this.coords = opts.coords;
        this.geoObject = opts.geoObject;
    }

    set coords(value) {
        var parsed = undefined;

        if (!value) {
            parsed = undefined;
        } else if (Array.isArray(value)) {
            if (value.length === 2) {
                // координаты в формате [0: lat, 1: lng]
                parsed = value;
            } else {
                console.warn('Array not coords format', value);
            }
        } else {
            if (!value.lat || !value.lng) {
                console.warn('Lat or Lng coord not found', value);
            } else {
                // координаты в формате {lat: lat, lng: lng}
                parsed = [value.lat, value.lng];
            }
        }

        try {
            if (parsed) {
                const lat = parseFloat(parsed[0]);
                const lng = parseFloat(parsed[1]);

                if (isNaN(lat) || isNaN(lng)) {
                    throw new Error('Неверный формат координат');
                }

                parsed = [lat, lng];
            }
        } catch (err) {
            console.warn(err, this);
        }

        Object.defineProperty(this, '_coords', {
            value: parsed,
            enumerable: false,
            writable: true,
            configurable: true,
        });
    }

    get coords() {
        return this._coords;
    }
}
